import ImageBox from "./ImageBox";
import Footer from "./Footer";
export default function Card() {
  return (
    <div className="card">
      <ImageBox />
      <Footer />
    </div>
  );
}
